const { Badge, Progress } = require("reactstrap");

const getStatusBadge = (
  status,
  active = "ACTIVE",
  inactive = "INACTIVE",
  pending = "PENDING",
) => {
  return status === "ACTIVE" ? (
    <Badge color="success">{active}</Badge>
  ) : status === "INACTIVE" ? (
    <Badge color="danger">{inactive}</Badge>
  ) : (
    <Badge color="warning">{pending}</Badge>
  );
};

//Deal List Coloumns

const revenueProgressFormatter = (cell) => {
  if (!cell) return null;

  const value = parseInt(cell?.replace("%", ""), 10);

  return (
    <div style={{ minWidth: "120px" }}>
      <div className="d-flex justify-content-between mb-1">
        <small>{value}%</small>
      </div>
      <Progress value={value} max={"100"} color={"success"} />
    </div>
  );
};

export { getStatusBadge, revenueProgressFormatter };
